import { render, staticRenderFns } from "./SettlementStatements.vue?vue&type=template&id=6200d097&scoped=true"
import script from "./SettlementStatements.vue?vue&type=script&lang=js"
export * from "./SettlementStatements.vue?vue&type=script&lang=js"
import style0 from "./SettlementStatements.vue?vue&type=style&index=0&id=6200d097&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6200d097",
  null
  
)

export default component.exports